import React from "react";
import { useAccessibility } from "../../context/AccessibilityContext/AccessibilityContext";

const AccessibleWrapper = ({ children, background, color, ...props }) => {
    const { settings } = useAccessibility();

    const style = {
        background: settings.contrast !== 'default'
            ? 'var(--bg-primary)'
            : background,
        color: settings.contrast !== 'default'
            ? 'var(--text-primary)'
            : color,
        ...props.style
    };

    return React.cloneElement(children, {
        ...props,
        style
    });
};

export default AccessibleWrapper;